import { render, staticRenderFns } from "./Direcciones.vue?vue&type=template&id=4f7fe368&"
import script from "./Direcciones.vue?vue&type=script&lang=js&"
export * from "./Direcciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports